module.exports = __webpack_public_path__ + "img/option-1.4b999f81.png";